import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';

import { createChannelCollectionQueryOptions } from './queryOptions';

type PrefetchChannelCollectionArgs = {
  referenceId: string;
};

export function prefetchChannelCollection({ referenceId }: PrefetchChannelCollectionArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return Promise.resolve();
  }

  if (!category.channels[0]) {
    return Promise.resolve();
  }

  return queryClient.prefetchQuery(createChannelCollectionQueryOptions(category));
}
